import React from 'react';
import { Grid, Typography } from '@mui/material';
import { withStyles, styled } from "@mui/styles";

import en from "../../i18n/English/Policies/privacyPolicy.json";
import hi from "../../i18n/Hindi/Policies/privacyPolicy.json";
import kn from "../../i18n/Kannada/Policies/privacyPolicy.json";
import ma from "../../i18n/Marathi/Policies/privacyPolicy.json";
import gu from "../../i18n/Gujarati/Policies/privacyPolicy.json";
import { useLanguage } from "../../Context/LangContext";
import DocumentMeta from 'react-document-meta'

const meta = {
    title: 'Privacy Policy | Data Protection & Secure Trading | TradeBoss',
    description: 'Read TradeBoss Privacy Policy to understand how we safeguard your personal data and demat account for secure, compliant stock trading.',
    canonical: 'https://tradeboss.co/Privacy_Policy',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'tradeboss privacy policy, data protection trading platform, how is personal data used, privacy in demat accounts, user data security, GDPR / India privacy laws trading'
        }
    }
}
const styles = theme => ({
    heading: {
        textTransform: 'none !important', color: '#000000 !important', fontFamily: 'Inter500 !important', fontSize: 'calc(24px + var(--font-delta)) !important',
        marginBlockStart: 0, marginBlockEnd: 0, fontWeight: 'normal',
        "@media only screen and (max-device-width: 480px)": {
            fontFamily: 'Inter500 !important', fontSize: 'calc(20px + var(--font-delta)) !important'
        }
    },
    p_body: {
        textTransform: 'none !important', color: '#000000 !important', fontFamily: 'Inter400 !important', fontSize: 'calc(16px + var(--font-delta)) !important', lineHeight: "22px !important",
        "@media only screen and (max-device-width: 480px)": {
            fontFamily: 'Inter400 !important', fontSize: 'calc(14px + var(--font-delta)) !important', lineHeight: "20px !important",
        }
    },
    p_1: {
        padding: '20px 0px 0px 0px',
        "@media only screen and (max-device-width: 480px)": {
            padding: '2px 0px 0px 0px',
        }
    }
})

const PrivacyPolicy = ({ classes }) => {
      const { language } = useLanguage();
          const translations = { en, hi, kn ,ma ,gu};
          const t = translations[language];
    return (
        <main style={{ height: 'auto' }}>
            <DocumentMeta {...meta} />
            <Grid className={classes.p_1}>
                <h1 className={classes.heading}>
                    {t.privacyPolicy[0].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[0].content}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[0].content1}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[0].content2}
                </Typography>

                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[1].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[1].content}
                </Typography>

                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.privacyPolicy[2].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[2].content}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[2].content1}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[2].content2}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[2].content3}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[2].content4}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.privacyPolicy[3].title}
                </h1>
                <h1 className={classes.heading} style={{ padding: '10px 0px 0px 0px' }}>
                    {t.privacyPolicy[3].content}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[3].content1}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[3].content2}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.privacyPolicy[4].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[4].content}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[4].content1}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[4].content2}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[4].content3}
                </Typography>

                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.privacyPolicy[5].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[5].content}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[5].content1}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.privacyPolicy[6].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[6].content}
                </Typography>
                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[7].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[7].content}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[7].content1}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[7].content2}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[7].content3}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[7].content4}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.privacyPolicy[8].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[8].content}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[8].content1}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    <ul>
                        <li> {t.privacyPolicy[8].text}</li>
                        <li> {t.privacyPolicy[8].text1}</li>
                        <li> {t.privacyPolicy[8].text2}</li>
                        <li> {t.privacyPolicy[8].text3}</li>
                    </ul>
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[8].text4}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    <ul>
                        <li>  {t.privacyPolicy[8].text5}</li>
                        <li> {t.privacyPolicy[8].text6}</li>
                        <li> {t.privacyPolicy[8].text7}</li>
                        <li> {t.privacyPolicy[8].text8}</li>
                        <li> {t.privacyPolicy[8].text9}</li>
                        <li> {t.privacyPolicy[8].text10}</li>
                        <li> {t.privacyPolicy[8].text11}</li>
                        <li> {t.privacyPolicy[8].text12}</li>
                    </ul>
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.privacyPolicy[8].text13}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[8].text14}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.privacyPolicy[9].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[9].content}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[9].content1}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[9].content2}
                </Typography>
                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.privacyPolicy[10].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[10].content}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.privacyPolicy[11].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.privacyPolicy[11].content}</Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 50px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.privacyPolicy[11].content1}
                </Typography>
            </Grid>
        </main>
    );
}

export default withStyles(styles)(PrivacyPolicy);